
import fieldTypes from './contact-fields-types';

export default [
  { value: 'first_name', name: 'First name', type: fieldTypes.CONTACT_FIELD },
  { value: 'last_name', name: 'Last name', type: fieldTypes.CONTACT_FIELD },
  { value: 'email', name: 'Email address', type: fieldTypes.CONTACT_FIELD },
  { value: 'secondary_email', name: 'Secondary email', type: fieldTypes.CONTACT_FIELD },
  { value: 'mobile_phone', name: 'Mobile phone number', type: fieldTypes.CONTACT_FIELD },
  { value: 'home_phone', name: 'Home phone number', type: fieldTypes.CONTACT_FIELD },
  { value: 'office_phone', name: 'Office phone number', type: fieldTypes.CONTACT_FIELD },
  { value: 'fax', name: 'Fax', type: fieldTypes.CONTACT_FIELD },
  { value: 'company', name: 'Company', type: fieldTypes.CONTACT_FIELD },
  { value: 'birthday', name: 'Birthday', type: fieldTypes.CONTACT_FIELD },
  { value: 'anniversary', name: 'Anniversary', type: fieldTypes.CONTACT_FIELD },
  { value: 'spouse_name', name: 'Spouse name', type: fieldTypes.CONTACT_FIELD },
  { value: 'spouse_email', name: 'Spouse email address', type: fieldTypes.CONTACT_FIELD },
  { value: 'spouse_phone', name: 'Spouse phone number', type: fieldTypes.CONTACT_FIELD },
  { value: 'spouse_birthday', name: 'Spouse birthday', type: fieldTypes.CONTACT_FIELD },
  { value: 'source_id', name: 'Contact Source', type: fieldTypes.CONTACT_FIELD },
  { value: 'hotness_id', name: 'Hotness', type: fieldTypes.CONTACT_FIELD },
  { value: 'tags', name: 'Tags', type: fieldTypes.CONTACT_FIELD },
  { value: 'comment', name: 'Comment', type: fieldTypes.CONTACT_FIELD },
  { value: 'type_id', name: 'Contact type', type: fieldTypes.CONTACT_FIELD },
  { value: 'status', name: 'Status', type: fieldTypes.CONTACT_FIELD },
];
